import { render, staticRenderFns } from "./CarnivoreParent.vue?vue&type=template&id=575a09c2&"
import script from "./CarnivoreParent.vue?vue&type=script&lang=js&"
export * from "./CarnivoreParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports